import _ from 'lodash';
import React from "react";
import * as AccountApi from './AccountApi';
import AccountConstants from './AccountConstants';
import { createNotification } from "Data/notifications/NotificationActions";
import {CheckCircleIcon, XCircleIcon} from "@heroicons/react/outline";
import Promise from "promise-polyfill";

const receivedAccount = (account) => ({
    type: AccountConstants.ACCOUNT_RECEIVED,
    payload: {
        id: account.id,
        name: account.name,
        slug: account.slug,
        website: account.website,
        timezone: account.timezone,
        role: account.role
    }
});

const accountSelected = (accountId, role) => ({
    type: AccountConstants.ACCOUNT_SELECTED,
    payload: {
        id: accountId,
        role: role
    }
});

export function selectAccount(accountId) {
    return function (dispatch, getState) {
        const account = _.find(getState().accounts, ['id', accountId]);
        return new Promise(function (resolve, reject) {
            dispatch(accountSelected(accountId, account.role));
            resolve(accountId);
        })
    }
}

// ---

export function fetchAccountList() {
    return function (dispatch) {
        return AccountApi.listAccounts().then(accounts => {
            _.map(accounts, account => {
                dispatch(receivedAccount(account));
            });

            return accounts;
        });
    };
}

export function updateDetails(name, website, timezone) {
    return function (dispatch, getState) {
        const accountId = getState().currentAccountId;

        return AccountApi.updateDetails(accountId, name, website, timezone)
            .then(() => dispatch(
                createNotification(
                    'Details Updated Successfully!',
                    <CheckCircleIcon className="h-6 w-6 text-green-400" />
                )
            ))
            .catch(error => dispatch(
                createNotification(
                    'There was a problem updating your details.',
                    <XCircleIcon className="h-6 w-6 text-red-400" />
                )
            ));
    }
}